import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "src/shared/store";
import { ProductSummary } from "./model/ProductSummary";
import { ProductModalErrors } from "./model/ProductModalError";

export interface ProductsState {
  isVisible: boolean; // product modal visibility
  productSummary: ProductSummary | null; // undetailed data for fast display
  errors: ProductModalErrors;
}

const initialErrors = {
  unselectedVariants: [],
  waitForStreamStart: [],
};

const initialState: ProductsState = {
  isVisible: false,
  productSummary: null,
  errors: initialErrors,
};

export const productModalSlice = createSlice({
  name: "productModal",
  initialState,
  reducers: {
    setProductModalVisibility: (state, action) => {
      state.isVisible = action.payload;
    },

    setProductSummary: (state, action) => {
      state.productSummary = action.payload;
    },
    clearProductSummary: (state, action: PayloadAction<void>) => {
      state.productSummary = null;
    },
    addModalError: (state, action) => {
      const { type, key } = action.payload;
      if (!state.errors[type].some((error) => error.key === key)) {
        state.errors[type].push(action.payload);
      }
    },
    removeModalError: (state, action) => {
      const { type, key } = action.payload;
      state.errors[type] = state.errors[type].filter(
        (error) => error.key !== key
      );
    },
    clearModalErrorType: (state, action) => {
      const { type } = action.payload;
      state.errors[type] = [];
    },
    clearAllModalErrors: (state, action: PayloadAction<void>) => {
      state.errors = initialErrors;
    },
  },
});

export const {
  setProductModalVisibility,
  setProductSummary,
  addModalError,
  removeModalError,
  clearModalErrorType,
  clearAllModalErrors,
  clearProductSummary,
} = productModalSlice.actions;

export const productModalVisibleSelector = (state: RootState) =>
  state.productModal.isVisible;

export const productSummarySelector = (state: RootState) =>
  state.productModal.productSummary;

export const productModalErrorsSelector = (state: RootState) =>
  state.productModal.errors;

export default productModalSlice.reducer;
